export const RouteUrls = {
    Logout: '/logout',
    Login: '/login',
    Signup: '/signup',
    Landing: '/landing',
    Admin: '/admin',
};
